<template>
  <div>
    <right-panel :datas="connects" :items="connects" @onClose="onCloseForm" @onSubmit="onSubmitForm" ref="right-mfa-panel">
      <div slot="header">
        <translate>Unbind MFA</translate>
      </div>
    </right-panel>
  </div>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'AccountMfaClose',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null
      }
    },
    methods: {
      // 确定关闭mfa
      onSubmitForm () {
        this.$refs['right-mfa-panel'].onClose()
        let params = {
          data: Object.assign({otp_enabled: 0}, this.$refs['right-mfa-panel'].profileModel)
        }
        this.$store.dispatch(STORE_CONST.ACCOUNT.POST_MFA_CODE, params).then(() => {
          this.$notify({
            message: this.$gettext('Close Successfully!'),
            type: 'success'
          })
          this.$emit('callback', this.$store.getters.account.id)
        })
      },
      // 关闭修改mfa
      onCloseForm () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">

</style>



// WEBPACK FOOTER //
// account-close-mfa.vue?514ddc18